import { Component, Input, OnInit } from '@angular/core';
import { ReportIssueConfiguration, ReportIssueType } from './reports-issue.configuration';
import { CtBinaryOperator, CtButtonConfiguration, CtControlConfiguration, CtControlService, CtControlTypes, CTModelDatatableFilter, CtModelDatatableOperators, CtModelService, CtSelectControlOptions, CtSortOrderDescriptorParameter, CtThemeTypes, MAT_RAISED_PRIMARY } from '@ctsolution/ct-framework';
import { QtaControl } from 'projects/ct-manager/src/app/_core/constants';
import { DataRequest, MethodEnum } from '@ctsolution/ct-webapi';
import { FileService } from 'projects/ct-manager/src/app/_core/lib/file.service';

@Component({
  selector: 'app-reports-issue-card',
  templateUrl: './reports-issue-card.component.html',
  styleUrls: ['./reports-issue-card.component.scss']
})
export class ReportsIssueCardComponent {

  @Input() configuration: ReportIssueConfiguration | null = null;

  qtyControl: CtControlConfiguration = QtaControl("qty").setLabel("Anno").setValue(this.getAnnoCorrente());

  InvoiceDueDateFromControl: CtControlConfiguration = this.controlService.getDefaultConfiguration({
    name: 'InvoiceDueDateFrom',
    label: 'Da',
    type: CtControlTypes.DATE
  }).setTheme(CtThemeTypes.MATERIAL).setNullValueEnabled(true).setFlexSpacePercentage(40);

  InvoiceDueDateToControl: CtControlConfiguration = this.controlService.getDefaultConfiguration({
    name: 'InvoiceDueDateTo',
    label: 'A',
    type: CtControlTypes.DATE
  }).setTheme(CtThemeTypes.MATERIAL).setNullValueEnabled(true);

  supplierControl: CtControlConfiguration =
    this.controlService.getDefaultConfiguration({
      name: 'Supplier',
      label: 'Supplier',
      type: CtControlTypes.LOOKUP,
      remoteValueOptionsEndpoint: DataRequest
        .create()
        .setController(['Company'])
        .setAction('LookupForSuppliers')
        .setMethod(MethodEnum.POST)
        .setQueryParams({ hideSpinner: true })
    })
      .setNullValueEnabled(true)
      .setTheme(CtThemeTypes.MATERIAL)
      .configureOptions<CtSelectControlOptions>(options => {

        if (!options) options = CtSelectControlOptions.create();

        options
          .setNullValueEnabled(false)
          .setLookupFilter((value) => {

            const filters: CTModelDatatableFilter[] = [];

            if (value) {

              filters
                .push(
                  CTModelDatatableFilter
                    .create()
                    .setField("[ReferenceName] is not null AND Contains([ReferenceName], ?)")
                    .setValue([value])
                    .setOperatorType(CtBinaryOperator.OrOperator),
                  CTModelDatatableFilter
                    .create()
                    .setField("[FiscalCode] is not null AND Contains([FiscalCode], ?)")
                    .setValue([value])
                    .setOperatorType(CtBinaryOperator.OrOperator),
                  CTModelDatatableFilter
                    .create()
                    .setField("[VAT] is not null AND Contains([VAT], ?)")
                    .setValue([value])
                    .setOperatorType(CtBinaryOperator.OrOperator),

                );

            }

            filters.push(CTModelDatatableFilter
              .create()
              .setField("Active")
              .setValue(true)
              .setOperatorType(CtBinaryOperator.Equal));


            const operators = CtModelDatatableOperators
              .create()
              .setFilters(filters);

            operators
              .Pagination
              ?.setSortOrders(new Array<CtSortOrderDescriptorParameter>(CtSortOrderDescriptorParameter.create('Name')))

            return operators;

          })

      })


  submitButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel(this.configuration?.ButtonLabel ?? "Scarica")
    .setClass('ct-model-submit-button')
    .setAction(() => this.submit())
    .setIcon('download')
    .setMatherialOptions(MAT_RAISED_PRIMARY);


  constructor(private fileService: FileService, private controlService: CtControlService) { }

  submit() {

    if (!this.qtyControl.value) return

    const parameter = {

      year: +this.qtyControl?.value,
      SupplierOid: this.supplierControl?.control?.value?.value ? +this.supplierControl.control.value.value : null,
      InvoiceDueDateFrom: this.InvoiceDueDateFromControl?.value ? this.InvoiceDueDateFromControl.value.toISOString() : null,
      InvoiceDueDateTo: this.InvoiceDueDateToControl?.value ? this.InvoiceDueDateToControl.value.toISOString() : null

    }

    const request: DataRequest = new DataRequest()
      .setController(["Handling"])
      .setAction(this.getAction())
      .setBody(parameter)
      .setMethod(MethodEnum.POST);

    this.fileService
      .getFile(request)
      .subscribe(result => {

        this.fileService.blobDownload(result, `${this.configuration?.Title}_${this.qtyControl.value}`)

        return result;

      })
  }


  getAction() {

    switch (this.configuration?.Type) {

      case ReportIssueType.SALE:
        return 'ExportExcelHandlingByYear';
      case ReportIssueType.RESALE:
        return 'ExportExcelHandlingRetailByYear';
      default:
        return '';

    }

  }

  /**
 * Restituisce l'anno corrente come numero
 * @returns {number} L'anno corrente (es: 2025)
 */
  getAnnoCorrente(): number {
    return new Date().getFullYear();
  }

}
